import React from 'react';
import Item from '../DropdownItem/DropdownItem';
import { useNewlyCreatedListings } from '../../hooks/useNewlyCreatedListings';
import IconSpinner from '../../../IconSpinner/IconSpinner';
import { useTopbarContext } from '../../TopbarContext';
import { getUserAddress } from '../../../../util/location';
import { getSortByDateFieldFromListingType } from '../../../../containers/SearchPage/SearchPage.helpers';

export default ({ searchParams, heading }) => {
    const { currentUserGeoData } = useTopbarContext();
    const { listings, error, loading } = useNewlyCreatedListings(searchParams);

    if (error) return null;
    if (!Array.isArray(listings)) return null;
    if (loading) return <IconSpinner />;

    const { origin, bounds, address } = currentUserGeoData || {};

    const noData = listings.length === 0;
    const defaultAddress = getUserAddress();

    const locationSearchParams = {
        origin: origin ? `${origin?.lat},${origin?.lng}` : defaultAddress?.origin,
        bounds: bounds
            ? `${bounds?.ne?.lat},${bounds?.ne?.lng},${bounds?.sw?.lat},${bounds?.sw?.lng}`
            : defaultAddress?.bounds,
        address: address || defaultAddress?.address,
    };

    const sortByDateField = getSortByDateFieldFromListingType(searchParams.pub_type);

    return (
        <Item
            name="SearchPage"
            searchParams={{
                sort: sortByDateField,
                ...locationSearchParams,
                ...searchParams,
                listingType: searchParams.pub_type,
            }}
        >
            <Item.Icon />
            <Item.Content>
                <Item.Heading>{heading}</Item.Heading>
                <Item.Description highlight={!noData}>
                    {noData ? 'Finden in der Nähe' : `${listings.length}+ neu dabei`}
                </Item.Description>
            </Item.Content>
        </Item>
    );
};
